import { render, staticRenderFns } from "./core-transaction-routing.vue?vue&type=template&id=02b5a742&scoped=true"
import script from "./core-transaction-routing.vue?vue&type=script&lang=js"
export * from "./core-transaction-routing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5a742",
  null
  
)

export default component.exports